import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './contact.css'

const Contact = (props) => {
  return (
    <div
      id={props.contactId}
      className={`contact-container1 ${props.rootClassName} `}
    >
      <span id="contactmeid" className="contact-title">
        {props.contactTitle ?? (
          <Fragment>
            <span className="contact-text5">Contact me</span>
          </Fragment>
        )}
      </span>
      <span className="contact-text1">
        {props.contactText ?? (
          <Fragment>
            <span className="contact-text2">
              <span>
                Feel free to reach out if you have interesting opportunities or
                just want to discuss the fascinating world of data! Connect with
                me on LinkedIn or check out my articles on Medium or projects on
                GitHub.
              </span>
              <br></br>
            </span>
          </Fragment>
        )}
      </span>
      <div className="contact-container2">
        <a
          href="https://github.com/stefan-Lacher"
          target="_blank"
          rel="noreferrer noopener"
          className="contact-link1"
        >
          <img
            alt={props.gitHubImageAlt}
            src={props.gitHubImageSrc}
            className="contact-git-hub"
          />
        </a>
        <a
          href="mailto:contact@stefanlacher.com?subject=Contact from stefanlacher.com"
          className="contact-link2"
        >
          <img
            alt={props.eMailImageAlt}
            src={props.eMailImageSrc}
            className="contact-e-mail"
          />
        </a>
        <a
          href="https://www.linkedin.com/in/stefan-lacher"
          target="_blank"
          rel="noreferrer noopener"
          className="contact-link3"
        >
          <img
            alt={props.linkedinImageAlt}
            src={props.linkedinImageSrc}
            className="contact-linkedin"
          />
        </a>
        <a
          href="https://medium.com/@stefan-lacher"
          target="_blank"
          rel="noreferrer noopener"
          className="contact-link4"
        >
          <img
            alt={props.mediumImageAlt}
            src={props.mediumImageSrc}
            className="contact-medium"
          />
        </a>
      </div>
    </div>
  )
}

Contact.defaultProps = {
  contactText: undefined,
  linkedinImageAlt: 'image',
  gitHubImageSrc: '/github2-200h.webp',
  mediumImageAlt: 'image',
  rootClassName: '',
  eMailImageAlt: 'image',
  eMailImageSrc: '/email2-200h.webp',
  mediumImageSrc: '/medium2-200h.webp',
  gitHubImageAlt: 'image',
  contactTitle: undefined,
  contactId: 'contact',
  linkedinImageSrc: '/linkedin2-200h.webp',
}

Contact.propTypes = {
  contactText: PropTypes.element,
  linkedinImageAlt: PropTypes.string,
  gitHubImageSrc: PropTypes.string,
  mediumImageAlt: PropTypes.string,
  rootClassName: PropTypes.string,
  eMailImageAlt: PropTypes.string,
  eMailImageSrc: PropTypes.string,
  mediumImageSrc: PropTypes.string,
  gitHubImageAlt: PropTypes.string,
  contactTitle: PropTypes.element,
  contactId: PropTypes.string,
  linkedinImageSrc: PropTypes.string,
}

export default Contact
